<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(title) }}</h2>

    <form [formGroup]="patientForm" class="patient-form">
      @if (!onlyNewAppointment) {
        <mat-form-field appearance="fill">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="firstName" type="text" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Cognome</mat-label>
          <input matInput formControlName="lastName" type="text" />
        </mat-form-field>
        <mat-slide-toggle formControlName="isNewAppointmentSelected">
          {{
            labelService.getLabel(
              "do_you_already_want_to_book_the_first_interview"
            )
          }}
        </mat-slide-toggle>
      }

      @if (
        patientForm.get("isNewAppointmentSelected")?.value || onlyNewAppointment
      ) {
        <mat-form-field appearance="fill">
          <mat-label>Titolo</mat-label>
          <input matInput formControlName="appointmentTitle" type="text" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Data</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="appointmentDate"
            appDateInput
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="time-fields">
          <mat-form-field appearance="fill">
            <mat-label>Ora</mat-label>
            <input matInput formControlName="appointmentTime" type="time" />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Durata (minuti)</mat-label>
            <input matInput formControlName="appointmentLength" type="number" />
          </mat-form-field>
        </div>
        <mat-slide-toggle formControlName="isRemote">Online</mat-slide-toggle>
      }
    </form>

    <div class="panel-buttons">
      <button class="button-white" mat-stroked-button (click)="onCancel()">
        {{ labelService.getLabel("close") }}
      </button>
      <button
        class="button-white"
        mat-raised-button
        (click)="onConfirm()"
        [disabled]="patientForm.invalid || isBtnClicked"
      >
        {{ labelService.getLabel("send") }}
      </button>
    </div>
  </div>
</div>
